import {Grid, Button, TextField as MuiTextField } from "@mui/material";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import React, { useState } from "react";
import {
  Loading,
  minValue,
  number,
  ReferenceInput,
  required,
  useDataProvider,
  useRedirect,
  useRecordContext,
  AutocompleteInput,
  SelectInput
} from "react-admin";
import { useWatch } from "react-hook-form";
import { PriceInput } from "src/components/input/PriceInput";
import { CurrencyEnum } from "src/common/enum/CurrencyEnum";
import { priceFormat } from "src/common/UtilFunctions";
import { RbacWrapperForm} from "src/components/common/RbacWrapperForm";

export const PriceForm = () => {
  const parentId = useWatch({ name: "parent.id" });
  const dataProvider = useDataProvider();
  const product = useRecordContext();
  const [parent, setParent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const redirect = useRedirect();

  function redirectToEdit() {
    redirect("/admin/products/" + product?.parent.id + "/" + 5);
  }

  function CustomField({ title, content }) {
    return (
      <MuiTextField
        sx={{ my: 0.5, input: { height: "8px" } }}
        label={title}
        value={content}
        disabled
        variant="outlined"
      />
    );
  }

  React.useEffect(() => {
    if (!parentId) {
      setParent(null);
      setLoading(false);
      setError(undefined);
    } else {
      dataProvider
        .getOne("admin/products", { id: parentId })
        .then(({ data }) => {
          setParent(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    }
  }, [parentId]);

  if (loading) return <Loading />;
  if (error) return <h3>Error</h3>;

  let component = <></>;

  const btnStyle = {
    background: "none !important",
    border: "none",
    padding: "0 !important",
    fontSize: "inherit",
    color: "#069",
    textDecoration: "underline",
    cursor: "pointer",
  };
  const validatePrice = [required(), number(), minValue(0)];

  if (!product?.price && parent?.price) {

    component = (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <CustomField
            title="Price"
            content={`${priceFormat(
              parent?.price?.price,
              parent?.price?.currency
            )}`}
          />
          <CustomField
            title="Manufacturer Price"
            content={`${priceFormat(
              parent?.price?.manufacturer_price,
              parent?.price?.manufacturer_currency
            )}`}
          />
          { parent?.price?.sales_price > 0 &&
          <CustomField
            title="Sales Price"
            content={parent?.price?.sales_price}
          />
          }
          <CustomField
            title="Tax class"
            content={parent?.price?.tax_class.name}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",

            alignItems: "center",
          }}
        >
          <p>Prices are stored on parent product:</p>
          <Button
            onClick={redirectToEdit}
            variant="outlined"
            startIcon={<LaunchOutlinedIcon />}
          >
            {product?.parent.sku + " " + product?.parent.name}
          </Button>
        </div>
      </div>
    );
  }
  if ((!product?.price && (!parent || !parent?.price)) || product?.price)
    component = (
      <RbacWrapperForm>
        <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <SelectInput
              source="price.currency"
              label="Currency"
              choices={CurrencyEnum}
              sx={{ mt: "10px" }}
              defaultValue=""
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceInput
              source="price.price"
              label="Price"
              format={(v) => String(v / 100)}
              parse={(v) => parseFloat(v) * 100}
              currencyField="price.currency"
              validate={validatePrice}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              source="price.manufacturer_currency"
              label="Manufacturer Currency"
              choices={CurrencyEnum}
              sx={{ mt: "10px" }}
              defaultValue=""
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceInput
              source="price.manufacturer_price"
              label="Manufacturer Price"
              format={(v) => String(v / 100)}
              parse={(v) => parseFloat(v) * 100}
              currencyField="price.manufacturer_currency"
              validate={validatePrice}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="price.tax_class.id"
              reference="admin/taxes"
              perPage={50}
            >
              <AutocompleteInput
                optionText="name"
                label="Tax Class"
                sx={{ mt: "10px" }}
                size="small"
                defaultValue=""
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceInput
              source="price.sales_price"
              label="Sales Price"
              format={(v) => String(v / 100)}
              parse={(v) => parseFloat(v) * 100}
              currencyField="price.currency"
              validate={validatePrice}
            />
          </Grid>
        </Grid>
      </RbacWrapperForm>
    );
  return component;
};
